<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>パラフレーズ機能</h1>
                            <h2>より明確で<br/>
                                伝わりやすい英文に</h2>
                                <p>Trinkaのパラフレーズ機能で、元の文意を保ったまま、より分かりやすい英文の表現を確認できます。</p>
                                
                            <div class="btn-group">
                                <a href="https://cloud.trinka.ai/signup?_rg=JP" class="filled-btn" target="_blank">登録・ログイン</a>
                            </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="assets/images/paraphraser/online_paraphrase_banner.svg" alt="言い換え者" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="howItWorks section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src="assets/images/yt-thumbnail/online-phraphraser-video-banner.webp" alt="言い換え者 - 英文 チェック" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2">
                        <div class="trinka-title mb-0">
                            <h2>使い方を見る</h2>
                            <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                            <p>Trinkaのパラフレーズ機能の使い方を短い動画でご覧いただけます。</p>
                            <p>パラフレーズ機能の使い方をステップごとにご紹介しています。</p>
                            <p><a style="color: #0000ff;" (click)="scroll(target)" class="text-link">FAQ</a>もあわせてお読みください。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    

    <div class="writeToolboxs_section section-pd pb-0">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-10 col-md-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinka パラフレーズ機能の主な特徴</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>手早く直感的に、英語の文章を効果的に言い換え・書き換えできるパラフレーズ機能。使い方は簡単です。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>いつものダッシュボードで
                            スムーズにパラフレーズ </h3>
                        <p>パラフレーズ機能はTrinkaの既存のソフトウェアに統合されています。使い慣れたユーザーインターフェイスで簡単にパラフレーズを行えます。</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image list-wrapper-video">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="assets/images/paraphraser/videos/speed-up-paraphrase.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-pd list-wrapper-style-2 pt-0">
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2 pr-80">
                        <h3>変更レベルの調整 </h3>
                        <p>Trinkaのパラフレーズ機能では、言い換えの度合いを指定できます。これにより、どの程度までのパラフレーズを行うかを調整できます。</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image list-wrapper-video">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="assets/images/paraphraser/videos/level-of-variation.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-pd list-wrapper-style-2 pt-0">
        <div class="trinka_container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>複数候補からの選択</h3>
                        <p>Trinkaでは、複数の言い換え・書き換え候補を提示。文章の目的や全体のトーンに合わせて最適な語句・文を使ったパラフレーズを選べます。</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image list-wrapper-video">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="assets/images/paraphraser/videos/aternatives.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-pd list-wrapper-style-2 pt-0">
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2 pr-80">
                        <h3>簡単な操作</h3>
                        <p>わずか数クリックで、パラフレーズされた文言を対象箇所に反映させることができます。</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image list-wrapper-video">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="assets/images/paraphraser/videos/Replaced-Paraphrase.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-pd list-wrapper-style-2 pt-0">
        <div class="trinka_container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>変更箇所が一目瞭然で<br/>
                            仕上げも簡単</h3>
                        <p>Trinkaではパラフレーズされたテキストとともに、原文に加えられた変更が変更履歴として明示されます。</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image list-wrapper-video">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                            <source src="assets/images/paraphraser/videos/show-revisions.mp4" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="cloud_key_features section-pd list-wrapper-style-2 pt-0">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinkaのパラフレーズ機能を使うメリット</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <img src="assets/images/paraphraser/icon1.svg" alt="効率性の向上">
                        <h3>生産性の向上 </h3>
                        <p>Trinkaのパラフレーズ機能はTrinkaの既存のエディタに統合されたツールです。高い操作性で、時間の節約や生産性向上につながります。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <img src="assets/images/paraphraser/icon2.svg" alt="効果的に言い換える">
                        <h3>意図を保った豊かな表現</h3>
                        <p>パラフレーズの度合い指定、複数の言い換え候補からの語句・文の選択などにより、目的や意図に合った書き換えをユーザーが選べます。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <img src="assets/images/paraphraser/icon3.svg" alt="明瞭度の向上">
                        <h3>言語の精度</h3>
                        <p><a href="/grammar-checker" class="text-link">Trinkaの文法チェック機能との併用で、</a>単なる言い換えでなく、文法やスペル、文構造などに問題のない、明瞭な英文へのパラフレーズが可能です。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">パラフレーズ機能を試す</h3>
                    </div>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" class="white-btn" target="_blank">登録・ログイン</a>
                    </div>
                </div>
            </div>  
        </div>
    </div>

    <div class="allAboutTrinkaCredit list-wrapper-style-2 section-pd">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <span class="trinka-sub-title mx-auto">法人向け</span>
                        <h2>TrinkaパラフレーズAPI</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>既存のワークフローにTrinkaのパラフレーズ機能をAPIで連携させれば、組織全体のライティングの精度・効率が高まります。</p>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-lg-12">
                    <div class="api_img text-center">
                        <img src="assets/images/paraphraser/API.svg" class="img-fluid" alt="パラフレーズAPI" />
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-4 col-md-4">
                            <div class="list-wrapper-content-2 list-style-cards">
                                <h3>高速・スケーラブル</h3>
                                <p>Trinkaを使った迅速なパラフレーズにより、チーム全体のコンテンツ制作もスピードアップ。組織のニーズに合わせた拡張も簡単。</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4">
                            <div class="list-wrapper-content-2 list-style-cards">
                                <h3>高いデータセキュリティ</h3>
                                <p>すべてのデータには高度な暗号化が施され、大量のテキストを扱う場合もコンテンツの機密を保持。</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4">
                            <div class="list-wrapper-content-2 list-style-cards">
                                <h3>ニーズに沿ったカスタマイズ</h3>
                                <p>言い換えの度合いやパラフレーズの候補数は組織全体でカスタマイズ可能。チームの文章に明瞭性と統一感を。</p>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="aboutTrinkaCreditHeading list-wrapper-content-2 pr-80">
                        <ul class="row">
                            <li class="col-lg-4 col-md-4"><b>Fast and Scalable -</b> Trinka's rapid paraphrasing will help boost your teams content production and improve overall productivity. It's easily scalable with your organization's growing needs.</li>
                            <li class="col-lg-4 col-md-4"><b>Data Security -</b> All your data is under a highly encrypted environment. Your content remains confidential, no matter the volume of text you're working with.</li>
                            <li class="col-lg-4 col-md-4"><b>Customizable -</b> Paraphrasing levels and the number of rephrase options can be customized across your organization to ensure consistency. Achieve clarity and uniformity effortlessly.</li>
                        </ul>
                    </div> -->
                </div>
                
            </div>
        </div>
    </div>

    <div class="faqQuestionAnwser section-pd pt-0" #target>
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-10">
                    <div class="trinka-title text-center">
                        <h2>パラフレーズ機能に関するよくあるご質問</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="faqQuestionsList">
                <div class="accordion" id="faq">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionOne">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                            TTrinkaのパラフレーズ機能は無料で使えますか？</a>
                                    </div>
    
                                    <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                        <div class="card-body">
                                            <p>はい、無料でご利用いただけます。ただし、ベーシックプランでは、英文校正の5000単語に加え、パラフレーズ機能についても一か月あたり5000単語までの単語数制限があります。</p>
                                            <p>無制限アクセスをお求めの方は、プレミアムプランあるいはプレミアムプラスプランをご利用ください。必要なだけ何度でもパラフレーズ機能をご利用いただけます。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionTwo">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                            aria-controls="QuestionTwoContent">
                                            パラフレーズ機能を利用する際、情報は安全に保たれますか？ </a>
                                    </div>
    
                                    <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                        <div class="card-body">
                                            <p>はい、Trinkaには、高いデータセキュリティ基準に従った数多くの対策がなされています。ユーザーの皆様のデータは保護され、情報が漏洩することはありません。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionThree">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                            aria-controls="QuestionThreeContent">
                                            パラフレーズの度合い・変更レベルは自分のライティングスタイルに合わせてカスタマイズできますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                        <div class="card-body">
                                            <p>もちろんです。変更レベルはご自身で設定いただけます。文書の種類の指定や、複数の語句・文の候補の中からの選択もでき、お好みの文体や目的に合わせた書き換えが可能です。</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionFour">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                            aria-controls="QuestionFourContent">
                                            パラフレーズツールは専門的な内容にも対応していますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                        <div class="card-body">
                                            <p>Trinkaは学術論文やテクニカルライティングに特化したツールのため、専門性の高い文書を扱うのに最適です。パラフレーズ機能でも高い性能を発揮します。</p>
                                            <!-- <p>In addition to all the features you get in Basic, you also get Power Mode with a Premium subscription.  Power Mode provides users with up to 40% more suggestions for their content while considering the context of the writing. Furthermore, </p> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="otherApps section-pd-sm">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">ほかのアプリ内でもTrinkaを利用できます</h3>
                    </div>
                    <ul>
                        <li>
                            <a [routerLink]="['/trinkacloud']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="cloud">
                                    <h3>Cloud</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/wordplugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Others_App_MSWord.svg" alt="ms word">
                                    <h3><span class="OpenSansFonts" style="font-weight: bold;">MS Word</span>
                                        <br /> プラグイン</h3>
                                </div>
                        </a>
                        </li>
                        <li>
                            <a [routerLink]="['/browser-plugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/other_Apps_browser.svg" alt="browser">
                                    <h3>ブラウザ
                                        <br />プラグイン</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/enterprise']">
                                <div class="app_name_content" style="padding: 0px;">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                    <h3 style="margin: 0 0 -2px 0;">Enterprise</h3>
                                    <span style="font-size: 12px; color: #000; position: relative;">(API, JS, & On-Premise)</span>
                                </div>
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>

    
</div>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/qF_9Al4NHIY"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>